import React from 'react';
import { useSelector } from 'react-redux';
import SvgIcon from '../../main/components/SvgIcon';
import SectionHeaderWeb from '../../main/components/SectionHeaderWeb';
import { COLOURFUL_TEMPLATE_NAME } from '../../main/utils/const';

const Desirability = ({
  locales: { portfolioWeb },
  className,
  mainSvgColor,
  backgroundSection,
  sectionHeaderTitleColor,
  descriptionColor,
  templateName,
}) => {
  const { desirabilitySection } = useSelector((state) => state.portfolio);

  return (
    <div
      className={`${className} section-web`}
      style={{ backgroundColor: backgroundSection }}
    >
      {templateName === COLOURFUL_TEMPLATE_NAME && (
        <div className="svg-funDesirabilityTen" style={{ fill: mainSvgColor }}>
          <SvgIcon name="funDesirabilityTenth" />
        </div>
      )}
      <SectionHeaderWeb
        templateName={templateName}
        title={portfolioWeb.desirability}
        description={desirabilitySection.description}
        style={{ color: sectionHeaderTitleColor }}
        descriptionColor={descriptionColor}
      />
    </div>
  );
};

export default Desirability;
